module.exports = __webpack_public_path__ + "static/media/hlengiwe_gumede.850503f0.jpg";